import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const TextInput = styled.input`
   font-weight: normal;
  border: 1px solid #ccc;
  width: 100%;
  font-size: 0.86em;
  padding: 5px;
  background-color: #fff;
  font-family: inherit;
  // border-radius: 4px;
  &:disabled{
    background-color: ${(props) => props.dbc ? '' : 'lightgray'};
  }
`;

const TextLabel = styled.div`
  font-weight: normal;
  width: 100%;
  font-size: 0.86em;
  padding: 5px;
  background-color: ${(props) => props.dbc ? '' : 'lightgray'};
  font-family: inherit;
  width: 100%;
  min-height: 32px;
  .summary-content & {
    padding: 0px;
  }
  .summary-content .expenses & {
    margin-left: 30px;
  }
`;

// export default Textbox;

export default function Textbox(props) {
  if (props.disabled && !props.isSummary) {
    return <TextLabel disabled={props.disabled}>{props.value}</TextLabel>;
  }
  if (props.isSummary) {
    return (
      <TextLabel>{props.value || 'N/A'}</TextLabel>
    );
  }
  return <TextInput {...props} />;
}

Textbox.propTypes = {
  disabled: PropTypes.bool,
  isSummary: PropTypes.bool,
  value: PropTypes.string,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/components/Textbox/index.js